import React from 'react';
import ImageGallery from './ImageGallery';
import OrderStatusBadge from './atoms/OrderStatusBadge';
import OrderAccordion from './OrderAccordion';
import AdminOrderAccordion from "./AdminOrderAccordion";

const OrderCard = ({ order, isAdmin=true }) => {
  const orderDate = new Date(order.created_at).toLocaleDateString('fa-IR');

  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
      {isAdmin ? (
        <AdminOrderAccordion order={order} />
      ) : (
        <OrderAccordion order={order} />
      )}
    </div>
  );

};

export default OrderCard;
